<script>
import { onMount } from "svelte/internal";
import {sections} from "../stores"
import {newBlock} from "../constants"

import AddBlockMenu from "./AddBlockMenu.svelte";

    export let block;
    export let sectionIndex;
    export let rowIndex;
    export let addBlock;
    let showAddBlockMenu = false;

    function hideBlockMenu(){
        showAddBlockMenu = false;
    }

    function addTextBlock(){
        addBlock(sectionIndex, "text", null);
        return hideBlockMenu(); 
    }
    function addDonationBoxBlock(id){
        addBlock(sectionIndex, 'donationbox', id);
        return hideBlockMenu(); 
    }

    onMount(() => {
        if (!firebase.apps.length) {
        firebase.initializeApp(firebaseConfig);
      }
        (function(d,o,n,a,t,e){
    let dt=Date.now();a=d.createElement(o);a.src=n+"a.js?v="+dt;d.body.appendChild(a);
    t=d.createElement(o);t.src=n+"b.chunk.js?v="+dt;d.body.appendChild(t);
    e=d.createElement(o);e.src=n+"c.chunk.js?v="+dt;d.body.appendChild(e);
   })(window.document,'script','https://s.donorflow.net/db/');
    })
</script>
        <div class="df-block df-block-{block.contentType}">
            {#if block.contentType === 'donationbox'}
                <div id="donationbox" data-box="{block.content}"></div>
            {/if}
            {#if block.contentType === 'text'}
                {block.content}
            {/if}
            
            
            {#if showAddBlockMenu}
                <AddBlockMenu {addTextBlock} {addDonationBoxBlock} {sectionIndex} {hideBlockMenu} />
            {:else}
                <div class="df-add-content-btn shadow-sm" on:click={() => showAddBlockMenu = true}>+</div>
            {/if}
        </div>
<style>
.df-block {
    border: 1px solid #ffffff;
    padding: 20px;
}
.df-block:hover {
    border: 1px dashed #f9f9f9;
}
.df-block:hover .df-add-content-btn {
    visibility: visible;
}

.df-add-content-btn {
    visibility: hidden;
    animation: visibility 400;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #E8E8E8;
    border-radius: 20px;
    color: #242424;
    width: 50px;
    text-align: center;
    cursor: pointer;
    height: 25px;
    margin: 0 auto;
    margin-bottom: -35px;
    z-index: 99;

}
</style>